import {
    WHATSAPP_NOTICE_ROWS,
    type ReminderChannels,
    type WhatsAppNoticeRow,
    type WhatsAppNotices,
} from "../../domain/ReminderChannels";

/**
 * `GET /notifications/reminder-channels` as it arrives.
 *
 * Every field optional: an older backend answers with the two legacy flags
 * and no rows, and a row it has never heard of is simply absent.
 */
export interface ReminderChannelsResponse {
    whatsapp_session_messages?: boolean;
    whatsapp_payment_messages?: boolean;
    whatsapp_notices?: Partial<Record<WhatsAppNoticeRow, boolean>>;
}

/**
 * The server's answer, with every gap read as email.
 *
 * Only a literal `true` counts. A row the answer does not mention is false,
 * and is never inferred from the legacy flags: an older backend that only
 * reports "some session message" cannot say which row, and guessing would
 * offer a WhatsApp option the deployment cannot send.
 */
export function readReminderChannels(
    raw: ReminderChannelsResponse | null | undefined
): ReminderChannels {
    const rows = raw?.whatsapp_notices;
    return {
        whatsapp_session_messages: raw?.whatsapp_session_messages === true,
        whatsapp_payment_messages: raw?.whatsapp_payment_messages === true,
        whatsapp_notices: Object.fromEntries(
            WHATSAPP_NOTICE_ROWS.map((row) => [row, rows?.[row] === true])
        ) as WhatsAppNotices,
    };
}
